import { connect } from 'react-redux';

import * as actions from 'common/actions';
import FlashMessages from 'components/shared/FlashMessages';

const mapStateToProps = state => ({
  flashMessages: state.flashMessages,
});

const mapDispatchToProps = dispatch => ({
  makeClearForId: id => () => {
    dispatch(actions.clearFlashMessage(id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlashMessages);
